/*
 * File: 基础设置-组织架构-同步日志管理
 */
<template>
    <div class="organization-log">
        <Paper class="organization-log-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @search-change="logList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.agree"
                        type="primary"
                        size="mini"
                        title="同意"
                        icon="el-icon-circle-check"
                        @click="handleBatch('1')"
                    >同意</lotsButton>
                    <lotsButton
                        v-has="authorityCode.ignore"
                        type="primary"
                        size="mini"
                        title="忽略"
                        icon="el-icon-circle-close"
                        @click="handleBatch('3')"
                    >忽略</lotsButton>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="tableBoxRef"
                        :height="tableHeight"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.columns"
                        :actions="config.actions"
                        v-loading="logList.tableLoading"
                        :rows="logList.totalData"
                        :selectable="(row) => +row.processStatus === 0 && row.changeType !== 'del'"
                        @selection-change="selectionChange"
                        @action-click="handleActive"
                    >
                        <template v-slot:col-append="{ col, row }">
                            <lots-button
                                v-has="authorityCode.process"
                                v-show="col.prop === 'userName'"
                                type="text"
                                size="mini"
                                @click.stop="handleProcess(row)"
                            >{{ row.userName }}</lots-button>
                            <div v-if="col.prop === 'uapUserChangeDetailList'">
                                <p v-for="(val, index) in row.uapUserChangeDetailList" :key="index" class="organization-log-change-detail">
                                    {{ val.changeFieldName }}
                                    ：
                                    <el-tag type="danger" style="text-decoration: line-through;">{{ val.oldValueName || '-' }}</el-tag>
                                    &rarr;
                                    <el-tag type="success">{{ val.newValueName || '-' }}</el-tag>
                                </p>
                            </div>
                            <!-- 用户状态 -->
                            <el-tag v-if="col.prop === 'enableFlag'" :type="+row.enableFlag === 1 ? 'success' : 'danger'">
                                {{ formatDictCodeToName(row[col.prop], dictData[col.optionsKey]) }}
                            </el-tag>
                            <!-- 处理状态 -->
                            <el-tag v-if="col.prop === 'processStatus'" :type="+row.processStatus === 1 ? 'success' : 'danger'">
                                {{ formatDictCodeToName(row[col.prop], dictData[col.optionsKey]) }}
                            </el-tag>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="logList.sizeChange"
                        :current-page.sync="logList.pageNo"
                        @current-change="logList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="logList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>

        <!-- 处理变更 -->
        <ProcessDialog ref="processDialogRef" @confirm="logList.getList()" />
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated } from '@vue/composition-api';
import { Message } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import utils from '@/components/utils/common.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import ProcessDialog from './component/processDialog.vue';
import { getOrganizationLogList, agreeAndIgnoreOrganizationLog } from '@mdm/api/basicSettings/organization.js';
import { config as configStatic } from './config';

export default {
    name: 'organizationLog',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        tableBox,
        lotsPagination,
        ProcessDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.organizationLog);
        const config = reactive(configStatic);
        const dictData = ref({});
        const selectionList = ref([]);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map((v) => ({
                        ...v,
                        uapUserChangeDetailList: v.uapUserChangeDetailList?.map((d) => ({
                            ...d,
                            oldValueName: formatDict(d.oldValue, d.changeField),
                            newValueName: formatDict(d.newValue, d.changeField)
                        }))
                    }));
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.tableBoxRef.$refs.elTable.doLayout(); // 解决表格错位
                });
            };
        }
        const logList = new AccountListClass({
            Api: {
                listApi: getOrganizationLogList // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.syncTimeFixed) {
                condition.startTime = utils.formatDateTimestamp(condition.syncTimeFixed[0]);
                condition.endTime = utils.formatDateTimestamp(condition.syncTimeFixed[1]);
                Reflect.deleteProperty(condition, 'syncTimeFixed');
            }

            const newParams = { ...condition, ...params };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 监听复选框选中
        const selectionChange = (selection) => {
            selectionList.value = selection;
        };
        // 批量同意/忽略
        const handleBatch = (handleStatus) => {
            if (!selectionList.value.length) {
                Message.warning('请至少选择一条记录');
                return;
            }
            const ids = selectionList.value.map((v) => v.id);
            handleAgreeAndIgnore({ ids, handleStatus });
        };
        // 操作项
        const handleActive = (event, row) => {
            // 处理
            if (event === 'process') {
                handleProcess(row);
            }
            // 同意
            if (event === 'agree') {
                handleAgreeAndIgnore({ ids: [row.id], handleStatus: '1' });
            }
            // 忽略
            if (event === 'ignore') {
                handleAgreeAndIgnore({ ids: [row.id], handleStatus: '3' });
            }
        };
        // 处理
        const handleProcess = (row) => {
            if (row.changeType !== 'del') {
                setupContext.refs.processDialogRef.show(row.id, dictData.value);
            }
        };
        // 同意/忽略
        const handleAgreeAndIgnore = (params) => {
            agreeAndIgnoreOrganizationLog(params).then(res => {
                if (+res.code === 0) {
                    Message.success('操作成功');
                    logList.getList();
                }
            }).finally(() => {});
        };
        // 字典转换
        const formatDict = (val, field) => {
            let dict = {};
            // 用户层级
            if (field === 'userLevelCode') {
                dict = dictData.value['LCRM_USER_LEVEL'];
            }
            // 账号状态
            if (field === 'enableFlag') {
                dict = dictData.value['LCRM_USER_STATUS'];
            }
            // 在职状态
            if (field === 'employeeStatus') {
                dict = dictData.value['LCRM_USER_EMPLOYEE_STATUS'];
            }
            return Object.keys(dict).length ? formatDictCodeToName(val, dict) : val;
        };

        onActivated(() => {
            setupContext.refs.tableBoxRef.$refs.elTable.doLayout(); // 解决表格错位
        });
        onMounted(async () => {
            const queryParams = {
                syncTimeFixed: utils.defaultDate('7'), // 默认选中前7天
                processStatus: '0'
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
            // 获取字典数据
            const { data } = await getDictDataApi({ dictCodes: 'LCRM_USER_LEVEL,LCRM_USER_STATUS,LCRM_USER_EMPLOYEE_STATUS,LCRM_USER_PROCESSED_STATUS' });
            dictData.value = data || {};
        });

        return {
            config,
            authorityCode,
            dictData,
            logList,
            formatDictCodeToName,
            selectionChange,
            handleBatch,
            handleProcess,
            handleActive
        };
    }
};
</script>

<style lang="less" >
.organization-log {
    width: 100%;
    .organization-log-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.organization-log-paper {
        padding: 0px 0px 0px;
    }
    .organization-log-change-detail {
        margin: 0;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
